<textarea #host></textarea>